/* eslint-disable @next/next/no-img-element */
import API from "@unisearch/helpers/api";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { HiUserGroup } from "react-icons/hi";
import { MdLibraryBooks } from "react-icons/md";
import { useRecoilValue } from "recoil";
import styles from "./group_heading.module.scss";

const list = [
  {
    image: "assets/images/persons/person1.png",
  },
  {
    image: "assets/images/persons/person2.png",
  },
  {
    image: "assets/images/persons/person3.png",
  },
  {
    image: "assets/images/persons/person4.png",
  },
  {
    image: "assets/images/persons/person5.png",
  },
  {
    image: "assets/images/persons/person6.png",
  },
  {
    image: "assets/images/persons/person7.png",
  },
  {
    image: "assets/images/persons/person8.png",
  },
  {
    image: "assets/images/persons/person9.png",
  },
  {
    image: "assets/images/persons/person1.png",
  },
];

export const GroupHeading = ({ groupDetails }) => {
  const { asPath, query, push } = useRouter();
  const [status, setStatus] = useState(false);
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();

  const handleFollow = async () => {
    if (profileInfo) {
      await API.post("/public/forum", {
        groupId: groupDetails?.forumGroupId,
      }).then(async (res) => {
        if (!res.error) {
          await getStatus();
        }
      });
    } else {
      systemActions.setReturnUrl(asPath);
      return push({ pathname: "/signin" });
    }
  };

  const getStatus = async () => {
    await API.get("/public/forum").then((res) => {
      if (!res.error && res.data === true) {
        setStatus(true);
      } else if (!res.error && res.data === false) {
        setStatus(false);
      }
    });
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.img_wrapper}>
        <img src={groupDetails?.coverImageSrc} alt="" />
      </div>

      <div className={styles.heading_wrapper}>
        <h2 className={styles.title}>{groupDetails?.title}</h2>
        <div className={styles.sub_heading_wrapper}>
          <div className={styles.icon_text_wrapper}>
            <span className={styles.group_icon}>
              <HiUserGroup />
            </span>
            <div className={styles.text}>
              {groupDetails?.totalMember === null
                ? "0"
                : groupDetails?.totalMember}
            </div>
          </div>
          <div className={styles.icon_text_wrapper}>
            <span className={styles.group_icon}>
              <MdLibraryBooks />
            </span>
            <div className={styles.text}>
              {groupDetails?.totalPost === null ? "0" : groupDetails?.totalPost}
            </div>
          </div>
        </div>
        <div className={styles.group_imgages}>
          <div>
            <ul className={styles.group_img_wrapper}>
              {groupDetails &&
                groupDetails?.followedUsers &&
                groupDetails?.followedUsers?.map((item, i) => (
                  <li className={styles.img_item_wrapper} key={i}>
                    <img src={item} alt="rashed" />
                  </li>
                ))}
            </ul>
          </div>
          <div>
            <button className={styles.follow_btn} onClick={handleFollow}>
              {status ? "Unfollow" : "Follow Now"}
            </button>
          </div>
        </div>
        <div className={styles.link_wrapper}>
          <ul>
            <li className={`${styles.link}`}>
              <Link legacyBehavior href={`/forum/group/${query.group_slug}`}>
                <a
                  className={
                    asPath === `/forum/group/${query.group_slug}`
                      ? `${styles.active_link}`
                      : ""
                  }
                >
                  About
                </a>
              </Link>
            </li>
            <li className={`${styles.link}`}>
              <Link
                legacyBehavior
                href={`/forum/group/${query.group_slug}/discussion`}
              >
                <a
                  className={
                    asPath === `/forum/group/${query.group_slug}/discussion`
                      ? `${styles.active_link}`
                      : ""
                  }
                >
                  Discussion
                </a>
              </Link>
            </li>
            <li className={`${styles.link}`}>
              <Link
                legacyBehavior
                href={`/forum/group/${query.group_slug}/topics`}
              >
                <a
                  className={
                    asPath.includes(`/forum/group/${query.group_slug}/topics`)
                      ? `${styles.active_link}`
                      : ""
                  }
                >
                  Topics
                </a>
              </Link>
            </li>
            <li className={`${styles.link}`}>
              <Link
                legacyBehavior
                href={`/forum/group/${query.group_slug}/media`}
              >
                <a
                  className={
                    asPath === `/forum/group/${query.group_slug}/media`
                      ? `${styles.active_link}`
                      : ""
                  }
                >
                  Media
                </a>
              </Link>
            </li>
            <li className={`${styles.link}`}>
              <Link
                legacyBehavior
                href={`/forum/group/${query.group_slug}/file`}
              >
                <a
                  className={
                    asPath === `/forum/group/${query.group_slug}/file`
                      ? `${styles.active_link}`
                      : ""
                  }
                >
                  File
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GroupHeading;
